"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringCharSource = void 0;
var CharSource_1 = require("./CharSource");
var EOFRuntimeException_1 = require("./EOFRuntimeException");
var StringCharSource = /** @class */ (function (_super) {
    __extends(StringCharSource, _super);
    function StringCharSource(str) {
        var _this = _super.call(this) || this;
        _this.str = str;
        return _this;
    }
    StringCharSource.prototype.read = function () {
        if (this.isEof(0))
            throw new EOFRuntimeException_1.EOFRuntimeException();
        return this.bookmark.append(this.str.charAt(this.bookmark.pos));
    };
    StringCharSource.prototype.peek = function (i) {
        if (i === void 0) { i = 0; }
        if (this.isEof(i))
            throw new EOFRuntimeException_1.EOFRuntimeException();
        return this.str.charAt(this.bookmark.pos + i);
    };
    StringCharSource.prototype.isEof = function (idx) {
        if (idx === void 0) { idx = 0; }
        return this.bookmark.pos + idx >= this.str.length;
    };
    StringCharSource.prototype.readUntil = function (target, predicate, minLen, maxLen) {
        if (minLen === void 0) { minLen = 0; }
        if (maxLen === void 0) { maxLen = Number.MAX_VALUE; }
        var startPos = this.bookmark.pos;
        var len = 0;
        var matched = false;
        for (; len < maxLen && !this.isEof(); len++) {
            matched = len >= minLen && predicate(this);
            if (matched)
                break;
            this.read();
        }
        if (target != null)
            target.append(this.str.substr(startPos, len));
        return matched;
    };
    return StringCharSource;
}(CharSource_1.CharSource));
exports.StringCharSource = StringCharSource;
//# sourceMappingURL=StringCharSource.js.map